// Services shown in the "Hizmetlerimiz" section. Source: docs/COMPANY_FACTS.md (Services).
// The Organization's knowsAbout in public/index.html repeats the Turkish names (checked by
// scripts/check-build.mjs).
export const services = {
  tr: [
    {
      name: "Özel yazılım geliştirme",
      description:
        "Finans kurumlarının ihtiyaçlarına göre esnek ve modüler yazılımlar geliştiriyoruz.",
    },
    {
      name: "Finansal süreç otomasyonu",
      description:
        "Finansal operasyonlardaki iş süreçlerini analiz ederek otomatikleştiriyor, operasyonel verimliliği artırıyoruz.",
    },
    {
      name: "Regülasyon uyumu, veri güvenliği ve sistem entegrasyonu",
      description:
        "Finans kurumlarının değişen regülasyonlara uyum sağlamasına, verilerini güvenle korumasına ve yeni çözümleri mevcut sistemlerine entegre etmesine destek oluyoruz.",
    },
    {
      name: "Yapay zeka ve dijital dönüşüm",
      description:
        "Yapay zeka ve yeni teknolojileri iş süreçlerine entegre ederek finans kurumlarının dijital dönüşümünü hızlandırıyoruz.",
    },
    {
      name: "Teknoloji danışmanlığı",
      description:
        "İş süreçlerini analiz ederek finans kurumlarına teknoloji ve strateji konularında danışmanlık veriyoruz.",
    },
  ],
  en: [
    {
      name: "Custom software development",
      description: "We build flexible, modular software tailored to the needs of financial institutions.",
    },
    {
      name: "Financial process automation",
      description:
        "We analyze business processes in financial operations and automate them to improve operational efficiency.",
    },
    {
      name: "Regulatory compliance, data security and system integration",
      description:
        "We help financial institutions comply with changing regulations, keep their data secure, and integrate new solutions with their existing systems.",
    },
    {
      name: "AI and digital transformation",
      description:
        "We speed up financial institutions' digital transformation by integrating AI and new technologies into their business processes.",
    },
    {
      name: "Technology consulting",
      description: "We analyze business processes and advise financial institutions on technology and strategy.",
    },
  ],
};
